import type { PropsWithChildren } from 'react'
import { Drawer, Items } from '@/scopes/common/components/Drawer/styled-components'
import { mqMin, space } from '@sunwebgroup/ui-components'
import { styled } from 'styled-components'

const Wrapper = styled.div`
  padding: 0 ${space('primitives_space_16')};
  width: 100%;
  display: flex;
  justify-content: center;
`

const QuickSearchDrawer = styled(Drawer)`
  top: 203px;
  left: 0;
  right: 0;
  position: absolute;
  width: calc(100% - 32px);
  max-width: 480px;
  min-height: 300px;

  @media ${mqMin('primitives_breakpoint_m_min')} {
    top: 229px;
  }
  @media ${mqMin('primitives_breakpoint_l_min')} {
    top: 277px;
    max-width: 960px;
    min-height: auto;
    height: 76px;
    padding-right: var(--primitives-space-16);
  }
`

export default function QuickSearchBarResponsive({
  disabled,
  children,
  className,
}: PropsWithChildren<{ disabled?: boolean, className?: string }>) {
  return (
    <Wrapper className={className}>
      <QuickSearchDrawer isDisabled={disabled}>
        <Items>{children}</Items>
      </QuickSearchDrawer>
    </Wrapper>
  )
}
